/* eslint-disable consistent-return */
/* eslint-disable no-plusplus */
export function getVideoType(url) {
  if (url) {
    const questionMarkIndex = url.indexOf('?');
    let dotIndex;

    for (let i = questionMarkIndex; i >= 0; i--) {
      if (url[i] === '.') {
        dotIndex = i;
        break;
      }
    }

    const videoType = url.slice(dotIndex + 1, questionMarkIndex);
    return videoType;
  }
}
